import React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const EditorConvertToHTML = ({ editorState, setEditorState, setHtmlDraftError }) => {


  const onEditorHandler = (state) => {
    setEditorState(state);
    const text = state.getCurrentContent().getPlainText().trim();
    setHtmlDraftError(!text ? 'This field is mandatory' : '');
  }


  return (
    <Editor
      editorState={editorState}
      wrapperClassName="html-editor-wrapper"
      editorClassName="html-editor-welcome-screen"
      onEditorStateChange={onEditorHandler}
      placeholder="Welcome letter text content..."
      toolbar={{
        fontSize: {
          options: [12, 14, 16],
        },
      }}
    />
  );
};

export default EditorConvertToHTML;
